import get from "lodash/get";
import words from "lodash/words";
import jwtDecode from "jwt-decode";
import { localStorage, getItem, setItem, removeItem } from "common/storage";

export function setAccessToken(token) {
  setItem(localStorage, "access_token", token);
}

export function setRefreshToken(token) {
  setItem(localStorage, "refresh_token", token);
}

export function getAccessToken() {
  return getItem(localStorage, "access_token");
}

export function getRefreshToken() {
  return getItem(localStorage, "refresh_token");
}

export function removeAccessToken() {
  removeItem(localStorage, "access_token");
}

export function removeRefreshToken() {
  removeItem(localStorage, "refresh_token");
}

export const isTokenExpired = (apiError) => {
  const { errors } = apiError.data;

  return (
    errors &&
    errors.some((err) => {
      return err.msg === "jwt expired";
    })
  );
};

export function decodeAccessToken(accessToken) {
  try {
    return jwtDecode(accessToken);
  } catch (e) {
    console.error("Failed to decode access token", e);
    return null;
  }
}

export function getTokenAccessLevel() {
  const accessToken = getAccessToken();
  const decodedToken = decodeAccessToken(accessToken);
  return get(decodedToken.user, "access_level");
}

export function getTokenPermissions() {
  const accessToken = getAccessToken();
  const decodedToken = decodeAccessToken(accessToken);
  if (!decodedToken) return [];
  const permissions = decodedToken.permissions || [];

  const parsedPermissions = permissions.map((permission) => {
    const permissionStringComponents = words(permission);
    const action = permissionStringComponents[0];
    const resourceType = permissionStringComponents[1];
    const resourceId = permissionStringComponents[2];

    return {
      action: action,
      resourceType: resourceType,
      resourceId: resourceId,
    };
  });

  return parsedPermissions;
}
